import { render, staticRenderFns } from "./PlanProvidersSentence.vue?vue&type=template&id=acde1eb4&lang=pug"
import script from "./PlanProvidersSentence.vue?vue&type=script&lang=js"
export * from "./PlanProvidersSentence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports